module.exports = __webpack_public_path__ + "img/integratedMarketing_1.3a453e6b.png";